
import React from "react";
export const Part1DataSource = {
  wrapper: { className: ' nailtool-part1-wrapper' },
  page: { className: 'nailtool-part1' },
  OverPack: { playScale: 0.3, className: '' },
  childWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: 'CanHealthy',
        className: 'title-h1',
      },
      {
        name: 'title',
        children: 'AI Vision-Based Orthopedic Internal Fixation Instrument Counting Series',
        className: 'title-h2',
      },
      {
        name: 'content',
        className: 'title-content nailtool-part1-title-content',
        children: '基于视觉AI的骨科内固定器械清点系列',
      },
    ],
  },
  video: {
    className: 'lipstick-part0-video',
    children: {
      video: process.env.SOURCE_URL+'/udi-nailtool-intro.mp4',
      image: process.env.SOURCE_URL+'/lipstick-img-1.png',
    },
  },
  image: {
    className: 'nailtool-part1-image',
    children:
    process.env.SOURCE_URL+'/nailtool-main.png',
  },

};


export const Part2DataSource = {
  wrapper: { className: 'home-page-wrapper nailtool-part2-wrapper'},
  page: { className: 'home-page nailtool-part2' },
  OverPack: { playScale: 0.3, className: '' },
  content:{
    className:'part2-content',
    children: (
      <div>
        <h3>自动分割，九颗成像，成像清晰，AI识别</h3>
      </div>
    ),
  },

  image: {
    className: 'nailtool-part2-image',
    children:
    process.env.SOURCE_URL+'/canhealthy-nail.png',
  }
}

export const Part3DataSource = {
  wrapper: { className: 'home-page-wrapper nailtool-part3-wrapper'},
  page: { className: 'home-page nailtool-part3' },
  OverPack: { playScale: 0.3, className: '' },
  content:{
    className:'part2-content',
    children: (
      <div>
        {/*<h1>满足大部分产线需求</h1>*/}
        <h3>AI识别，文本输出，比人工更高效、更准确</h3>
      </div>
    ),
  },

  image: {
    className: 'nailtool-part3-image',
    children:
    process.env.SOURCE_URL+'/single-nail.png',
  },
}

export const Part4DataSource = {
  wrapper: { className: 'home-page-wrapper nailtool-part4-wrapper'},
  page: { className: 'home-page nailtool-part4' },
  OverPack: { playScale: 0.3, className: '' },
  content:{
    className:'part4-content',
    children: (
      <div>
      <h3>可识别市面上大部分创伤钉*最小直径2mm</h3>
      </div>
    ),
  },

  image: {
    className: 'nailtool-part4-image',
    children:    process.env.SOURCE_URL+'/nailtool-five-single.png',

  },
}



export const Part5DataSource = {
  wrapper: { className: 'home-page-wrapper nailtool-part5-wrapper' },
  page: { className: 'home-page nailtool-part5' },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: '',
        className: 'title-h1',
      },
      {
        name: 'content',
        className: 'title-content',
        children: '支持对接各类系统，展示识别结果，交互简易友好',
      },
    ],
  },
  block: {
    className: 'nailtool-part5-block-wrapper',
    children: [

      {
        name: 'block0',
        className: 'nailtool-part5-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'nailtool-part5-icon',
            children:
              process.env.SOURCE_URL+'/pv/icon/6.png',
          },
          textWrapper: { className: 'nailtool-part5-text' },
          title: { className: 'nailtool-part5-title', children: '数据采集' },
          content: {
            className: 'nailtool-part5-content',
            children:
              '依据瓶体材质定制采集设备，兼容多种瓶体',
          },
        },
      },
      {
        name: 'block1',
        className: 'nailtool-part5-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'nailtool-part5-icon',
            children:
              process.env.SOURCE_URL+'/pv/icon/1.png',
          },
          textWrapper: { className: 'nailtool-part5-text' },
          title: { className: 'nailtool-part5-title', children: '数据筛选与清洗' },
          content: {
            className: 'nailtool-part5-content',
            children:
              '统计分类照片类别，细致专业，不浪费素材',
          },
        },
      },
      {
        name: 'block2',
        className: 'nailtool-part5-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'nailtool-part5-icon',
            children:
              process.env.SOURCE_URL+'/pv/icon/2.png',
          },
          textWrapper: { className: 'nailtool-part5-text' },
          title: { className: 'nailtool-part5-title', children: '数据标记' },
          content: {
            className: 'nailtool-part5-content',
            children:
              '专业可明数字化标记软件，供算法训练',
          },
        },
      },
      {
        name: 'block3',
        className: 'nailtool-part5-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'nailtool-part5-icon',
            children:
              process.env.SOURCE_URL+'/pv/icon/3.png',
          },
          textWrapper: { className: 'nailtool-part5-text' },
          title: { className: 'nailtool-part5-title', children: '模型开发与迭代' },
          content: {
            className: 'nailtool-part5-content',
            children:
              '自研算法模型，持续更新进步，不失效率',
          },
        },
      },
      {
        name: 'block4',
        className: 'nailtool-part5-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'nailtool-part5-icon',
            children:
              process.env.SOURCE_URL+'/pv/icon/4.png',
          },
          textWrapper: { className: 'nailtool-part5-text' },
          title: { className: 'nailtool-part5-title', children: '应用软件定制开发' },
          content: {
            className: 'nailtool-part5-content',
            children:
              '按需求定制开发软件，保证模型的调用效率',
          },
        },
      },
      {
        name: 'block5',
        className: 'nailtool-part5-block',
        md: 8,
        xs: 24,
        children: {
          icon: {
            className: 'nailtool-part5-icon',
            children:
              process.env.SOURCE_URL+'/pv/icon/5.png',
          },
          textWrapper: { className: 'nailtool-part5-text' },
          title: { className: 'nailtool-part5-title', children: '缺陷结果校验' },
          content: {
            className: 'nailtool-part5-content',
            children:
              '按不同的质检要求灵活调整算法模型',
          },
        },
      },
    ],
  },
};


export const Part6DataSource = {
  wrapper: { className: 'home-page-wrapper nailtool-part6-wrapper' },
  page: { className: 'home-page nailtool-part6' },
  childWrapper: {
    className: 'nailtool-part6-text-wrapper',
    children: [
      { name: 'title', children: '操作便捷、成本低、更高效', className: 'nailtool-part6-title' },
      {
        name: 'intro',
        className: 'nailtool-part6-intro',
        children: '',
      },
      
    ],
  },
  image: {
    className: 'nailtool-part6-image',
    children:
      process.env.SOURCE_URL+'/nailtool-part5.png',
  },
};


export const Part56DataSource = {
  wrapper: { className: 'home-page-wrapper banner5' },
  page: { className: 'home-page banner5-page' },
  childWrapper: {
    className: 'banner5-title-wrapper',
    children: [
      { name: 'title', children: '依据瓶体材质定制的视觉采集设备', className: 'banner5-title' },
      {
        name: 'explain',
        className: 'banner5-explain',
        children: '多重光源相机复合，兼容多种材质瓶体',
      },
      
    ],
  },
  image: {
    className: 'banner5-image',
    children:
      process.env.SOURCE_URL+'/jetcode/6.png',
  },
};
export const Part7DataSource = {
  wrapper: { className: 'home-page-wrapper nailtool-part7-wrapper' },
  page: { className: 'home-page nailtool-part7' },
  childWrapper: {
    className: 'nailtool-part7-text-wrapper',
    children: [
      // { name: 'title', children: '黑金刚2.0', className: 'banner5-title' },
      {
        name: 'intro',
        className: 'nailtool-part7-intro',
        children: '兼容主流的自动化剔除设备',
      },
      
    ],
  },
  image: {
    className: 'nailtool-part7-image',
    children:
      process.env.SOURCE_URL+'/jetcode/7.png',
  },
};
export const Part57DataSource = {
  wrapper: { className: 'home-page-wrapper banner5' },
  page: { className: 'home-page banner5-page' },
  childWrapper: {
    className: 'banner5-title-wrapper-1',
    children: [
      // { name: 'title', children: '黑金刚2.0', className: 'banner5-title' },
      {
        name: 'explain',
        className: 'banner5-explain-1',
        children: '兼容主流的自动化剔除设备',
      },
      
    ],
  },
  image: {
    className: 'banner5-image-1',
    children:
      process.env.SOURCE_URL+'/jetcode/7.png',
  },
};


  export const Part10DataSource = {
    wrapper: {
      className: 'case-wrapper-comp-wrapper',
    },
    page: {
      className: 'case-wrapper-comp',
    },
    OverPack: {
      playScale: 0.3,
      className: '',
    },
    titleWrapper: {
      className: 'title-wrapper',
      children: [
        {
          name: 'title',
          children: 'CanBeauty系列更多产品',
        },
      ],
    },
    block: {
      className: 'block-wrapper',
      children: [
        {
          name: 'block0',
          className: 'block',
          md: 8,
          xs: 24,
          href:'/lipstick',
          titleWrapper: {
            children: [
              {
                name: 'image',
                className: 'case-wrapper-comp-image',
                children: process.env.SOURCE_URL+'/lipstick-img-1.png',
              },
              {
                name: 'title',
                className: 'case-wrapper-comp-title',
                children: '口红产线质检',
              },
            ],
          },
        },
        {
          name: 'block1',
          className: 'block',
          md: 8,
          xs: 24,
          href:'/csar',
          titleWrapper: {
            children: [
              {
                name: 'image',
                className: 'case-wrapper-comp-image',
                children: process.env.SOURCE_URL+'/jetcode/2.png',
  
              },
              {
                name: 'title',
                className: 'case-wrapper-comp-title',
                children: 'CSAR合规辅助软件',
              },
            ],
          },
        },
        // {
        //   name: 'block2',
        //   className: 'block',
        //   md: 8,
        //   xs: 24,
        //   titleWrapper: {
        //     children: [
        //       {
        //         name: 'title',
        //         className: 'case-wrapper-comp-title title-1',
        //         children: '持续推出',
        //       },
        //     ],
        //   },
        // },
      ],
    },
  }

  export const Part8DataSource = {
    wrapper: { className: 'home-page-wrapper nailtool-part8-wrapper' },
    page: { className: 'home-page nailtool-part8' },
    OverPack: { playScale: 0.3, className: 'nailtool-part8-content-wrapper' },
    titleWrapper: {
      className: 'nailtool-part8-title-wrapper',
      children: [
        { name: 'title', children: '多种订阅方式', className: 'nailtool-part8-title-h1' },
      ],
    },
    Table: {
      name: 'tabsTitle',
      size: 'default',
      className: 'nailtool-part8-table',
      columns: {
        children: [
          {
            dataIndex: 'free',
            key: 'free',
            name: 'free',
            childWrapper: {
              className: 'nailtool-part8-table-name-block',
              children: [
                {
                  name: 'name',
                  className: 'nailtool-part8-table-name',
                  children: '永久授权',
                },
              ],
            },
          },
          {
            dataIndex: 'basic',
            key: 'basic',
            name: 'basic',
            childWrapper: {
              className: 'nailtool-part8-table-name-block',
              children: [
                {
                  name: 'name',
                  className: 'nailtool-part8-table-name',
                  children: '订阅授权',
                },
              ],
            },
          },
          {
            dataIndex: 'pro',
            key: 'pro',
            name: 'pro',
            childWrapper: {
              className: 'nailtool-part8-table-name-block',
              children: [
                {
                  name: 'name',
                  className: 'nailtool-part8-table-name',
                  children: '质检包授权',
                },
              ],
            },
          },
          {
            dataIndex: 'unlimited',
            key: 'unlimited',
            name: 'unlimited',
            childWrapper: {
              className: 'nailtool-part8-table-name-block',
              children: [
                {
                  name: 'name',
                  className: 'nailtool-part8-table-name',
                  children: '定制开发',
                },
              ],
            },
          },
        ],
      },
      dataSource: {
        children: [
          {
            name: 'list0',
            children: [
              {
                children: '一次性建设',
                name: 'content0',
                className: 'nailtool-part8-table-content',
              },
              {
                children: '按年采用订阅的方式',
                name: 'content1',
                className: 'nailtool-part8-table-content',
              },
              {
                children: '质检包授权',
                name: 'content2',
                className: 'nailtool-part8-table-content',
              },
              {
                children: '定制开发',
                name: 'content3',
                className: 'nailtool-part8-table-content',
              },
            ],
          },
        ],
      },
    },
  };
  